import {Link} from 'platform/foundation';

import i18n from '@dms/i18n';
import {vehiclesRoutes} from '@dms/routes';

import {composePath} from 'shared/web';

export type FactoryReferenceOwnerLinkProps = {
  vehicleId: string;
};

/** Opens the vehicle whose order holds the factory reference in a new tab, so the dialog stays. */
export function FactoryReferenceOwnerLink(props: FactoryReferenceOwnerLinkProps) {
  return (
    <Link
      size="small"
      target="_blank"
      rightIcon="action/launch"
      href={composePath(vehiclesRoutes.newVehicleDetail, {params: {id: props.vehicleId}})}
      title={i18n.t('entity.newVehicle.actions.openVehicle', {defaultValue: 'Open vehicle'})}
    />
  );
}
